import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='/#'
      className='link footer__link'
    >
      Bukunmi Odugbesan
    </a>
  </footer>
)

export default Footer;